// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__39Nnt","title":"ClientInsurance_title__2B7ZN","itemText":"ClientInsurance_itemText__2aDrs"};